import moment from "moment";
import "./customtable.less";
import "react-resizable/css/styles.css";
import { getInput } from "./helper";
import PPTableFilter from "./PPTableFilter";
import { Image, Table } from "antd";
import { FilterFilled } from "@ant-design/icons";
import { formatPrice } from "../../utils/format";
import { saveTableState } from "../../utils/localStorage";
import ReactDragListView from "react-drag-listview";
import { useEffect, useState } from "react";
import { Resizable } from "react-resizable";

const sortOrderDict = {
  1: "ascend",
  "-1": "descend",
};

const ResizableTitle = (props) => {
  const { onResize, width, ...restProps } = props;
  if (!width) {
    return <th {...restProps}></th>;
  }
  return (
    <Resizable
      width={width}
      height={0}
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => e.stopPropagation()}
        />
      }
    >
      <th {...restProps}></th>
    </Resizable>
  );
};

const PPTable = ({
  prefix,
  tableState,
  handleChangeTable,
  fetchList,
  size = "default",
  rowKey = "_id",
  customizeColumns,
  title = null,
  searchQuery = {},
  tablePrefix = "",
  ...restProps
}) => {
  const {
    columns = [],
    docs = [],
    pageSize,
    page,
    totalDocs,
    filteredKeys,
    // selectedRowKeys = [],
  } = tableState ?? {};
  const [customColumns, setCustomColumns] = useState([]);
  const {
    searchParams,
    handleChangeFilterValue,
    handleChangeFilterOperator,
    resetFilter,
    handleChangeSorter,
  } = searchQuery;
  const filter = searchParams.filter ?? {};
  const sorts = searchParams.sorts || [];
  const sortObject = {};
  sorts.forEach((sortItem) => {
    if (sortItem?.length === 2) sortObject[sortItem[0]] = sortItem[1];
  });

  const getColumnSearchProps = (dataIndex, col) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <PPTableFilter
        {...{
          searchParams,
          handleChangeFilterValue,
          handleChangeFilterOperator,
          resetFilter,
          column: col,
          tableState,
          handleChangeTable,
          fetchList,
          dataIndex,
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          close,
        }}
      />
    ),
  });

  const isDisabledInput = (inputType, enums) => {
    if (inputType === "date") return true; //Datepicker
    if (Array.isArray(enums) && enums.length > 0) return true; //Select
    return false;
  };

  const getColumnRender = (col, text, record) => {
    const columnName = col.key?.toUpperCase() ?? "";

    if (columnName === "CREATEDAT")
      return text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : text;
    if (columnName === "UPDATEDAT")
      return text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : text;
    if (columnName.indexOf("DATE") !== -1)
      return text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : text;

    if (columnName.indexOf("PRICE") !== -1)
      return <div>{formatPrice(text)}</div>;

    if (columnName.indexOf("IMAGE") !== -1)
      return (
        <Image
          src={text}
          alt="Зураг"
          style={{ width: 32, height: 32, objectFit: "contain" }}
        />
      );
  };

  const isCommonColumn = (name = "") => {
    const colName = name.toUpperCase();
    if (colName === "CREATEDAT") return true;
    if (colName === "UPDATEDAT") return true;
    if (colName.indexOf("DATE") !== -1) return true;
    if (colName.indexOf("PRICE") !== -1) return true;
    if (colName.indexOf("IMAGE") !== -1) return true;
  };
  const saveColsToLocalStorage = (cols = []) => {
    let colsObj = {};
    let key = tablePrefix + "_cols_sort_by_drag";
    cols.forEach((col, index) => {
      colsObj[col.key] = index;
    });

    localStorage.setItem(key, JSON.stringify(colsObj));
  };
  const handleResize =
    (column) =>
    (e, { size }) => {
      setCustomColumns((prevColumns) => {
        return prevColumns.map((col) => {
          if (col.key === column.key) {
            return {
              ...col,
              width: size.width,
            };
          }
          return col;
        });
      });
    };
  useEffect(() => {
    let tableColumns = customizeColumns ? customizeColumns(columns) : columns;
    tableColumns = tableColumns
      .map((col) => ({
        ...col,
        onHeaderCell: (column) => ({
          width: column.width || 150,
          onResize: handleResize(column),
        }),
      }))
      .filter((col) => col.show)
      .map((col) => {
        const { dataIndex } = col ?? {};
        const isFiltered = filteredKeys?.includes(dataIndex);
        const thChild = {
          dataIndex: col.key,
          render: isCommonColumn(col.key)
            ? (text, record) => getColumnRender(col, text, record)
            : undefined,
          ...col,
        };

        if (!thChild.render) delete thChild.render;

        const resCol = {
          ...col,
          title: (
            <div className="pp_col_header">
              <div className="pp_col_header_top">
                <span
                  className="dragHandler pp_col_header_name"
                  title={col.name ?? ""}
                >
                  {col.name || null}
                </span>
              </div>
              {col.isFilterable ? (
                <div className="pp_col_header_search">
                  {getInput({
                    inputType: col.instance,
                    enums: col.enum,
                    enumDictionary: col.enumDictionary,
                    value: filter[dataIndex]?.values?.[0]?.value,
                    onChange: (val) => {
                      val
                        ? handleChangeFilterValue({
                            dataIndex,
                            valueIndex: 0,
                            valueItem: { value: val },
                            defaultSearchType: col.defaultSearchType,
                          })
                        : resetFilter(dataIndex);
                    },
                    onPressEnter: (e) => {
                      fetchList({
                        ...searchParams,
                        search: filter,
                        pageSize: tableState.pageSize,
                        page: 1,
                      });
                    },
                    disabled: isDisabledInput(col.instance, col.enum),
                  })}
                </div>
              ) : null}
            </div>
          ),
          key: col.dataIndex,
          ellipsis: true,
          // ...getColumnSearchProps(col.dataIndex, col),
          filterIcon: () => (
            <FilterFilled
              style={{ color: isFiltered ? "#1890ff" : undefined }}
            />
          ),
          // children: [thChild],
          sorter: col.isSortable,
          sortOrder:
            `${col.dataIndex}` in sortObject
              ? sortOrderDict[sortObject[col.dataIndex]]
              : undefined,
        };

        if (col.isFilterable)
          Object.assign(resCol, getColumnSearchProps(col.dataIndex, col));
        return resCol;
      });
    setCustomColumns(tableColumns);
    // Багана бүтээх нь рендер бүрт шинээр үүсдэг олон helper-ээс хамаардаг тул
    // deps-д бүгдийг нь оруулбал төгсгөлгүй давтагдана. Зөвхөн багана/хайлтын
    // параметр солигдоход дахин байгуулна.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableState.columns, searchParams]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    if (extra?.action === "sort") {
      const { order, column } = sorter;
      handleChangeSorter(column?.children?.[0]?.dataIndex, order);
      let sort = [];
      if (column?.children?.[0]?.dataIndex) {
        if (order === "ascend") {
          sort = {
            [column?.children?.[0]?.dataIndex]: -1,
          };
        } else {
          sort = {
            [column?.children?.[0]?.dataIndex]: 1,
          };
        }
        fetchList({
          ...searchParams,
          search: filter,
          sort,
          pageSize: tableState.pageSize,
          page: 1,
        });
      }
    }
  };
  const onDragEnd = (fromIndex, toIndex) => {
    // +1 нь эхэнд байрлах дугаарлалтын багана, rowSelection байвал бас +1
    const offset = (restProps.rowSelection ? 1 : 0) + 1;
    const from = fromIndex - offset;
    const to = toIndex - offset;

    const draggedItem = customColumns[from];
    const nextColumns = [...customColumns];

    nextColumns.splice(from, 1);
    nextColumns.splice(to, 0, draggedItem);

    saveColsToLocalStorage(nextColumns);
    setCustomColumns(nextColumns);
  };

  const tableHeader = title
    ? typeof title === "string"
      ? () => <div className="pp_table_header">{title}</div>
      : () => title
    : "";

  const indexColumn = {
    title: "№",
    key: "__row_index__",
    dataIndex: "__row_index__",
    width: 60,
    align: "center",
    fixed: "left",
    onCell: () => ({
      style: { paddingLeft: 8, paddingRight: 8, whiteSpace: "nowrap" },
    }),
    render: (_text, _record, index) =>
      ((page || 1) - 1) * (pageSize || 0) + index + 1,
  };
  const renderColumns = [indexColumn, ...customColumns];
  return (
    <div className="pp_table_container">
      <ReactDragListView.DragColumn
        nodeSelector="th"
        handleSelector=".dragHandler"
        ignoreSelector=".react-resizable-handle"
        onDragEnd={onDragEnd}
      >
        <Table
          // rowSelection={rowSelection}
          rowKey={rowKey}
          size={size}
          columns={renderColumns}
          dataSource={docs}
          scroll={{
            x: renderColumns.reduce((group, item) => {
              return group + (item.width || 150);
            }, 0),
          }}
          pagination={{
            current: page,
            total: totalDocs,
            pageSize: pageSize,
            onChange: (page, pageSize) => {
              handleChangeTable({ page, pageSize });
              saveTableState(prefix, "page", page);
              saveTableState(prefix, "pageSize", pageSize);
              saveTableState(prefix, "totalDocs", totalDocs);
              fetchList({ page, pageSize, search: filter });
            },
            showSizeChanger: true,
            showTotal: (total) => `Нийт ${total} илэрц`,
            onShowSizeChange: (current, size) =>
              handleChangeTable({ pageSize: size }),
          }}
          title={tableHeader}
          onChange={handleTableChange}
          {...restProps}
          components={{
            header: {
              cell: ResizableTitle,
            },
          }}
        />
      </ReactDragListView.DragColumn>
    </div>
  );
};

export default PPTable;
